// extracted by mini-css-extract-plugin
export default {"container":"ParishBookPersonForm_container__kEYmn","actions":"ParishBookPersonForm_actions__sQFiG","checkboxContainer":"ParishBookPersonForm_checkboxContainer__n8Dgj"};